import React from "react";
import { FOOTER } from "../../../layout/eng/footer";
import { SUBHEADER } from "../../../layout/eng/subheader";
import { EN_History } from "../../../parts/eng/intro/history";
import { Helmet } from "react-helmet";
export const EN_HISTORY = () => {
  return (
    <main id="content">
      <SUBHEADER />
      <div id="intro">
        <EN_History />
      </div>
      <FOOTER />
    </main>
  );
};
